import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { decodePayload } from "../../utils/decoder";
import DataTable from "../../components/DataTable";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function PreUseDecoder() {
  const query = useQuery();
  const encoded = query.get("data");

  const [data, setData] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    try {
      if (!encoded) {
        setError("No data in URL");
        return;
      }

      const decoded = decodePayload(encoded);

      setData(decoded);
    } catch (e) {
      console.error(e);
      setError(`Failed to decode data${e?.message ? `: ${e.message}` : ""}`);
    }
  }, [encoded]);

  return (
    <div style={{ padding: 20 }}>
      <h2>Pre-use Check Report</h2>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {!error && <DataTable data={data} />}
    </div>
  );
}